import AppConstants from "../../../../../config/app.constants";
import BillableEventsBaseController from "../common/billable_events.base.controller"

class BillableEventsEditController extends BillableEventsBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, BillableEventsService, $q) {

        super(Auth, $state, User, BillableEventsService, Modal, $translate, $stateParams)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BillableEventsService = BillableEventsService;
        this.$q = $q;

        this.defaultModel = {
            isUpdating: false,
            branchId: User.getUser().branchId,
            entryType: null,
            billingCategory: null,
            description: null,
            errorMessage: '',
            billingCategoryObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            generalLedgerCode: null,
            isOrderCreate: false,
            createdBy: null,
            inventoryType: null
        }
         this.createdByOptions = [
            { label: 'Customer User', value: 'CUSTOMER_USER' },
            { label: 'Web User', value: 'WEB_USER' }
        ]
        this.inventoryTypeOptions = [
            { label: 'Regular', value: 'REGULAR' },
            { label: 'Emergency', value: 'EMERGENCY' }
        ]
        this.model = angular.copy(this.defaultModel)
    }

    $onInit() {
        this.$q.all([
            this.Service.get(this.$stateParams.id),
            this.getBillingCategory('', 0)
        ])
            .then((data) => {
                this.defaultModel = data[0];
                this.rawId = data[0].id;
                this.model.id = data[0].id;
                this.model.entryType = this.translateMessage(data[0].type);
                this.model.description = data[0].description;
                this.model.isOrderCreate = data[0].type === 'order-create';
                this.model.inventoryType = data[0].inventoryType;
                this.model.createdBy = data[0].createdBy;
                if (data[0].billingCategoryId) {
                    data[0].billingCategory.Key = data[0].billingCategory.name;
                    data[0].billingCategory.Value = data[0].billingCategory.id;
                }
                this.model.billingCategory = data[0].billingCategory;
                this.model.generalLedgerCode = data[0].generalLedgerCode;
            })
    }

    reset() {
        this.model.billingCategory = this.defaultModel.billingCategory;
        this.model.description = this.defaultModel.description;
        this.model.createdBy = this.defaultModel.createdBy;
        this.model.inventoryType = this.defaultModel.inventoryType;
        // this.model = angular.copy(this.defaultModel);
    }

    update() {
        this.model.isUpdating = true;
        delete this.model.errorMessage;

        this.Service.update(this.$stateParams.id, {
            event: this.model.entryType,
            billingCategoryId: this.model.billingCategory.Value,
            description: this.model.description,
            branchId: this.model.branchId,
            generalLedgerCode: this.model.generalLedgerCode,
            createdBy: this.model.createdBy,
            inventoryType: this.model.inventoryType
        })
            .then(() => {
                window.history.go(-1);
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isUpdating = false;
            })
    }

    translateMessage(key) {
        if (!key) return;
        return this.$translate.instant('entry_type.' + key);
    }

    getBillingCategory(searchKey, offset) {
        searchKey = searchKey || '';

        this.model.billingCategoryObj.loading = true;
        this.Service.getBillingCategory(searchKey, AppConstants.defaultPageLimit, offset)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.billingCategoryObj.totalRecords = data.total;
                    this.model.billingCategoryObj.results = this.billingCategoryMap(data.results);
                }
                else {
                    const results = this.billingCategoryMap(data.results);
                    this.model.billingCategoryObj.results = this.model.billingCategoryObj.results.concat(results);
                }
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.billingCategoryObj.loading = false;
            })
    }

    billingCategoryMap(events) {
        return events.map((data) => {
            return {
                Key: data.categoryName,
                Value: data.billingCategoryId
            }
        });
    }
}
export default BillableEventsEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/edit/billable_events.edit.controller.js